// Identity avatars: a person's photo when they have one, otherwise their
// initials on a color derived from their name (Google/Slack-style
// lettermark) — replaces the dead gray silhouette. Returned as an SVG
// data-URI so it drops into <img src> and background-image alike.

// Every hue holds ≥4.5:1 contrast with white text.
const PALETTE = [
  "#4C51BF", // indigo
  "#0E7490", // cyan-deep
  "#047857", // emerald
  "#B45309", // amber-deep
  "#BE185D", // pink-deep
  "#6D28D9", // violet
  "#B91C1C", // red-deep
  "#0F766E", // teal
  "#A21CAF", // fuchsia-deep
  "#1D4ED8", // blue
];

// "Emma Chen (Sample)" → "Emma Chen": tags in parens never make initials.
const cleanName = (name) => String(name || "").replace(/\(.*?\)/g, "").trim();

export const avatarColor = (name) => {
  const s = cleanName(name) || "?";
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
};

export const initialsOf = (name) => {
  const parts = cleanName(name).split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0][0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || "?";
};

const escapeXml = (s) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const cache = {};

export const initialsDataUri = (name) => {
  const key = cleanName(name) || "?";
  if (cache[key]) return cache[key];
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80">` +
    `<circle cx="40" cy="40" r="40" fill="${avatarColor(key)}"/>` +
    `<text x="40" y="40" dy=".36em" fill="#fff" font-family="Helvetica, Arial, sans-serif" ` +
    `font-size="30" font-weight="600" text-anchor="middle">${escapeXml(initialsOf(key))}</text>` +
    `</svg>`;
  // Consumers drop this into UNQUOTED css url(...) — escape the characters
  // encodeURIComponent leaves raw that would end the declaration early.
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29");
  cache[key] = `data:image/svg+xml,${encoded}`;
  return cache[key];
};

// The drop-in: real photo if present, initials lettermark if not.
const avatarFor = (name, url) => {
  if (url && url !== "") return url;
  return initialsDataUri(name);
};

export default avatarFor;
